import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export const SUBSCRIBER_ROLE_OPTIONS = [
  { value: "vendor", label: "Vendor", color: "#0b3d87", bg: "#eef2ff" },
  { value: "user", label: "Utente", color: "#166534", bg: "#ecfdf5" },
  { value: "unregistered", label: "Non registrato", color: "#475569", bg: "#f1f5f9" },
];

export const getSubscriberRoleMeta = (role) =>
  SUBSCRIBER_ROLE_OPTIONS.find((option) => option.value === role) || SUBSCRIBER_ROLE_OPTIONS[2];

export const SubscriberRoleChip = ({ role }) => {
  const meta = getSubscriberRoleMeta(role);
  return (
    <Chip
      label={meta.label}
      size="small"
      sx={{
        bgcolor: meta.bg,
        color: meta.color,
        fontWeight: 600,
        borderRadius: 1,
      }}
    />
  );
};

SubscriberRoleChip.propTypes = {
  role: PropTypes.string,
};
